import React from 'react';
import * as Utils from "logic/Utils";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from './UserAvatar.module.scss';

export function UserAvatar(props) {
  const { userName, hint, onClicked } = props;

  const colors = ["#00AA55", "#009FD4", "#B381B3", "#939393", "#E3BC00", "#D47500", "#DC2A2A"];
  const initials = Utils.getInitials(userName);
  const backgroundColor = Utils.colorFromText(initials, colors);

  return (
    <Button
      style={{backgroundColor: backgroundColor}}
      className={classes.avatarButton}
      stylingMode="text"
      hint={hint}
      text={initials}
      onClick={onClicked}
    />
  );
}